import { jsx as s, jsxs as S, Fragment as V } from "react/jsx-runtime";
import { createContext as $, useContext as j, useRef as z, useState as x, useLayoutEffect as B, useEffect as D } from "react";
import { c as C } from "./index-BpNK5r1N.mjs";
import { c as m } from "./tw-cn-mXgPecoF.mjs";
import { D as K } from "./divider-CiJqKcqY.mjs";
import { e as P } from "./extract-responsive-property-BiJ5BiwI.mjs";
const R = $(null), q = C("", {
  variants: {
    size: {
      large: "min-h-44",
      medium: "min-h-40"
    },
    pcSize: {
      large: "pc:min-h-44",
      medium: "pc:min-h-40"
    }
  },
  defaultVariants: {
    size: "medium",
    pcSize: "large"
  }
}), F = C(
  "w-auto relative flex items-center p-4 rounded-10 border border-line-neutral-weak3",
  {
    variants: {
      hasError: {
        true: "border-line-danger-main",
        false: "border-line-neutral-weak3"
      }
    }
  }
), M = ({
  size: n,
  pcSize: t,
  isSelected: r
}) => {
  const o = {
    large: r ? "typography-subtitle-16-bold" : "typography-subtitle-16-regular",
    medium: r ? "typography-body-14-bold" : "typography-body-14-regular"
  };
  return m(o[n], `pc:${o[t]}`);
}, A = ({
  label: n,
  value: t,
  className: r = "",
  size: o,
  disabled: l
}) => {
  const a = P({
    property: o,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "medium", pc: "large" }
  }), i = j(R);
  if (!i) throw new Error("SegmentedControlOption must be used inside SegmentedControl");
  const { selectedValue: d, onSelect: c } = i, f = d === t, p = q({ ...a }), g = (h) => {
    h.preventDefault(), !l && c(t);
  };
  return /* @__PURE__ */ s(
    "li",
    {
      className: m(
        "flex w-auto flex-1 items-center justify-center",
        {
          "pointer-events-none cursor-not-allowed bg-fill-neutral-weak": l
        },
        p,
        r
      ),
      "data-segment-value": t,
      role: "presentation",
      children: /* @__PURE__ */ s(
        "button",
        {
          className: m(
            "w-full rounded-8 p-4 disabled:text-interaction-neutral-disable-main hover-never:border-transparent hover-never:bg-interaction-neutral-presshover-weak1",
            p,
            M({ size: a.size, pcSize: a.pcSize, isSelected: f })
          ),
          disabled: l,
          onClick: g,
          role: "tab",
          type: "button",
          children: n
        }
      )
    }
  );
}, Y = ({
  options: n,
  value: t,
  onChange: r,
  className: o = "",
  size: l,
  segmentClassName: a,
  hasError: i = !1,
  errorMessage: d = ""
}) => {
  const c = z(null), [f, p] = x(!1), [g, h] = x({
    transform: "translate(0px, 0px)",
    width: 0,
    height: 0,
    opacity: 0
  }), [N, v] = x(!1), y = z(), k = F({ hasError: i }), E = () => {
    const e = c.current;
    return e ? e.querySelector(`[data-segment-value="${String(t)}"]`) : null;
  }, w = () => {
    const e = c.current, u = E();
    if (!e || !u) return;
    const L = e.getBoundingClientRect(), b = u.getBoundingClientRect(), O = b.left - L.left + e.scrollLeft - 1;
    h({
      transform: `translate(${O}px, 4px)`,
      width: b.width,
      height: b.height,
      opacity: 1
    });
  };
  B(() => {
    w();
  }, [t, n]), D(() => {
    p(!0);
    const e = () => {
      v(!0), w(), clearTimeout(y.current), y.current = setTimeout(() => {
        v(!1);
      }, 100);
    };
    return window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e), clearTimeout(y.current);
    };
  }, [t, n]);
  const T = n.findIndex((e) => e.value === t), I = n.length - 1;
  return /* @__PURE__ */ S(R.Provider, { value: { selectedValue: t, onSelect: r }, children: [
    /* @__PURE__ */ S("ul", { className: m(k, o), ref: c, role: "tablist", children: [
      /* @__PURE__ */ s(
        "div",
        {
          "aria-hidden": !0,
          className: m("pointer-events-none absolute rounded-8 border border-fill-neutral-main"),
          style: {
            left: 0,
            top: 0,
            ...g,
            // resizing 여부와 관계없이 transition을 적용하면 리사이징 중에 테두리가 출렁거리는 현상 발생
            transition: f && !N ? "transform 300ms ease-out, opacity 300ms ease-out" : "none"
          }
        }
      ),
      n.map((e, u) => /* @__PURE__ */ S(V, { children: [
        /* @__PURE__ */ s(A, { className: a, size: l, ...e }, e.value),
        u !== I && u !== T - 1 && /* @__PURE__ */ s(K, { className: "h-16 w-1" })
      ] }))
    ] }),
    i && d ? /* @__PURE__ */ s("p", { className: "mt-8 pl-16 text-text-warning-main", children: d }) : null
  ] });
};
export {
  R as S,
  A as a,
  Y as b
};
